/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid, Grid } from "frontend/src/components/Layout"
import { BlockText } from "frontend/src/components/BlockText"

function ImageOrVideo({ url, title }) {
  if (url.match(/\.(jpeg|jpg|gif|png)$/) !== null) {
    return <img src={url} alt={title} loading="lazy" sx={{ width: "100%" }} />
  }
  return (
    <video autoPlay loop muted playsInline sx={{ width: "100%" }}>
      <source src={url} type="video/mp4" />
    </video>
  )
}

function TextGridDesktop({ content, gifURL, title, gifRight }) {
  const gifColumn = gifRight ? "2 / span 1" : "1 / span 1"
  const textColumn = gifRight ? "1 / span 1" : "2 / span 1"
  return (
    <Grid columns="1fr 1fr" gap="20px" sx={{ display: ["none", "none", "grid"] }}>
      <div
        sx={{
          gridColumn: textColumn,
          gridRow: "1 / span 1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div>
          <h2
            sx={{
              fontFamily: "body",
              fontSize: ["7.4304vw", "29.7216px", "2.470608vw", "29.7216px"],
              fontWeight: 500,
              lineHeight: ["9vw", "36px", "2.9925vw", "36px"],
            }}
          >
            {title}
          </h2>
          <BlockText blocks={content} />
        </div>
      </div>
      <div sx={{ gridColumn: gifColumn, gridRow: "1 / span 1", width: "100%" }}>
        <ImageOrVideo url={gifURL} title={title} />
      </div>
    </Grid>
  )
}

function TextGridMobile({ content, gifURL, title }) {
  return (
    <div
      sx={{
        display: ["block", "block", "none"],
        width: ["89vw", "356px", "29.5925vw", "356px"],
        mx: "auto",
      }}
    >
      <div>
        <ImageOrVideo url={gifURL} title={title} />
      </div>
      <div>
        <h2
          sx={{
            fontFamily: "body",
            fontSize: ["5.4488vw", "21.7952px", "1.811726vw", "21.7952px"],
            fontWeight: 500,
            lineHeight: ["7.75vw", "31px", "2.576875vw", "31px"],
          }}
        >
          {title}
        </h2>
        <BlockText blocks={content} />
      </div>
    </div>
  )
}

function TextAnimatedGif({ title, gifURL, gifRight, content }) {
  return (
    <SectionGrid sx={{ py: 6, backgroundColor: "gray_100" }}>
      <SectionGrid.narrow>
        <TextGridDesktop title={title} gifRight={gifRight} gifURL={gifURL} content={content} />
        <TextGridMobile title={title} gifURL={gifURL} content={content} />
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { TextAnimatedGif }
